import { IAction } from 'core/interface/action';

export const SAVE_VALUES = 'save-companies';
export const SAVE_PUBLIC_VALUES = 'save-public-companies';
export const UPDATE_SUBSCRIPTION_LIMIT = 'update-subscription-limit';

export type SubscriptionCurrentLimit = {
  ai_credits?: number | string;
  jobs?: number | string;
  candidates?: number | string;
};

type CompanySubscription = {
  current_limit?: SubscriptionCurrentLimit;
};

type CompanyWithSubscription = {
  subscription?: CompanySubscription;
};

type CompaniesState = {
  companies: any | null;
  publicCompanies: any | null;
};

const defaultState: CompaniesState = {
  companies: null,
  publicCompanies: null
};

export const SaveCompanies = (value: any | number[]) => ({
  type: SAVE_VALUES,
  payload: value
});

export const SavePublicCompanies = (value: any | number[]) => ({
  type: SAVE_PUBLIC_VALUES,
  payload: value
});

export const UpdateSubscriptionLimit = (currentLimit: SubscriptionCurrentLimit) => ({
  type: UPDATE_SUBSCRIPTION_LIMIT,
  payload: currentLimit
});

const companiesReducer = (
  state: CompaniesState = defaultState,
  action: IAction<unknown>
): CompaniesState => {
  switch (action.type) {
    case SAVE_VALUES: {
      const incoming = action.payload as CompanyWithSubscription;
      const previous = state.companies as CompanyWithSubscription | null;
      return {
        ...state,
        companies: {
          ...incoming,
          subscription: incoming.subscription ?? previous?.subscription
        }
      };
    }
    case SAVE_PUBLIC_VALUES:
      return {
        ...state,
        publicCompanies: action.payload
      };
    case UPDATE_SUBSCRIPTION_LIMIT: {
      const companies = state.companies as CompanyWithSubscription | null;
      if (!companies) {
        return state;
      }
      const subscription = companies.subscription;
      const limit = action.payload as SubscriptionCurrentLimit;
      return {
        ...state,
        companies: {
          ...companies,
          subscription: {
            ...subscription,
            current_limit: {
              ...subscription?.current_limit,
              ...limit
            }
          }
        }
      };
    }
    default:
      return state;
  }
};

export default companiesReducer;
